import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import AppBar, {AppBarProps} from '@material-ui/core/AppBar';
import {Link as RouterLink} from "react-router-dom";
import Toolbar, {ToolbarProps} from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import {IconButton, ListSubheader, Menu, MenuItem, Typography} from "@material-ui/core";

import ThemeSettingsButton from "./ThemeSettingsButton";
import LanguageButton from "../Buttons/LanguageButton";
import UseFilterKeySearchBar from "./UseFilterKeySearchBar";
import UserActionButton from "./UserActionButton";
import NavMenuButton from "./NavMenuButton";

import TemplateSelectionButton from '../Buttons/TemplateSelectionButton';
import { TemplateSelection } from '../../../Utils/VersionTemplate';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    grow: {
      flexGrow: 1,
    },
    itemsMenuButton: {
      display: 'flex',
      marginLeft: 0,
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    menuItems: {
      flexDirection: 'row',
    },
    items: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'block',
      },
    },
    versionContainer: {
      display: 'none',
      [theme.breakpoints.up('lg')]: {
        display: 'block',
      },
    },
    versionText: {
      margin: theme.spacing(1),
      color: theme.palette.primary.contrastText,
    }
  }),
);

export interface NavBarMenuItem {
  path: string;
  title: string;
}

export interface TemplateChoices {
  "Event Seqeunce Diagram": Array<string>,
  "Fault Tree": Array<string>,
  "Bayesian Network": Array<string>
}

export interface NavBarProps {
  menuItems?: NavBarMenuItem[];
  version?: string;
  children?: any;
  appbarProps?: AppBarProps;
  toolbarProps?: ToolbarProps;
  templateChoices?: TemplateChoices
  onSet?: (selectedTemplates: TemplateSelection) => void
}

const NavBar = (props: NavBarProps) => {
  const classes = useStyles();
  const { version, children, menuItems, appbarProps, toolbarProps, templateChoices, onSet} = props;
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState<null | HTMLElement>(null);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const versionNumber = version ? <Typography variant="caption" color="textPrimary" className={classes.versionText}>{`v${version}`}</Typography> : null;
  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
      className={classes.menuItems}
      MenuListProps={{
        subheader: <ListSubheader component="div" id="nested-list-subheader">{versionNumber}</ListSubheader>,
        disablePadding: true
      }}
    >
      {menuItems.map((item: NavBarMenuItem) => <MenuItem onClick={handleMobileMenuClose} key={item.path} component={RouterLink} to={item.path}>{item.title}</MenuItem>)}
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar position="fixed" {...appbarProps}>
        <Toolbar {...toolbarProps}>
          <div className={classes.itemsMenuButton}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div className={classes.items}>
            {menuItems.map((item: NavBarMenuItem) => <NavMenuButton key={item.path} to={item.path}>{item.title}</NavMenuButton>)}
          </div>
          <div className={classes.grow} />
          <div className={classes.versionContainer}>{versionNumber}</div>
          {children}
          <UseFilterKeySearchBar />
          <ThemeSettingsButton />
          <LanguageButton />
          <UserActionButton />
          <TemplateSelectionButton templateChoices={templateChoices} onSet={onSet}/>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
    </div>
  );
};

export default NavBar;
